import { Tag } from '@/components'
import { AppIcon, variantProvider } from '@/app'
import { deepMerge } from '@codeleap/utils'

type TagTypeProps = {
  icon: AppIcon
  text?: string
}

export const TagType = ({ icon, text }: TagTypeProps) => {
  if (!icon) return null

  let style = styles.wrapper

  style = deepMerge(
    styles.wrapper,
    {
      trophy: styles.story,
      prompt: styles.prompt,
      'edit-3': styles.edit,
    }[icon] ?? {},
  )

  return (
    <Tag
      text={text}
      leftIcon={icon}
      leftIconProps={{
        // @ts-ignore
        variants: ['iconSize:1', 'iconColor:neutral6', 'padding:0'],
      }}
      textProps={{
        variants: ['p3', 'color:neutral9'],
      }}
      style={style}
    />
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    wrapper: {
      width: theme.values.iconSize[3],
      height: theme.values.iconSize[3],
      borderRadius: theme.borderRadius.tiny,
      alignSelf: 'auto',
      backgroundColor: theme.colors.primary1,
      ...theme.spacing.padding(0.5),
      ...theme.spacing.gap(0.5),
    },
    story: {
      width: 'auto',
      height: theme.values.iconSize[4],
      ...theme.spacing.padding(1),
    },
    prompt: {
      backgroundColor: theme.colors.acqua4,
    },
    edit: {},
  }),
  true,
)
